import FluffyTouchLeadComponent from "../FluffyTouchLeadComponent";
import GlazmaLeadComponent from "../GlazmaLeadComponent";
import GocLeadsComponent from "../GocLeadsComponent";
import RepairBuddyLeadComponent from "../RepairBuddyLeadComponent";

const AdminDashboard = ({ setShowNav, setShowLogout, logout, viewCompany }) => {
  return (
    <>
      <div className="goc-dashbord-right-side-main-head">
        <div>
          {" "}
          <span
            className="goc-dash-bord-menu-sm-open-ion"
            onClick={() => setShowNav(true)}
          >
            <i class="fa-solid fa-bars"></i>
          </span>{" "}
          Dashboard
        </div>

        {/* <div className="goc-dashbord-right-head-filter-container">
          <div className="goc-dashbord-search-input-cont">
            <spna className="goc-dashbord-search-icon">
              <i class="fa-solid fa-magnifying-glass"></i>
            </spna>
            <input
              type="text"
              placeholder="search..."
              value={searchinput}
              onChange={(e) => setSerchInput(e.target.value)}
            ></input>

             {searchinput ? (
              <spna
                className="goc-dashbord-search-close"
                onClick={() => setSerchInput("")}
              >
                <i class="fa-solid fa-circle-xmark"></i>
              </spna>
            ) : (
              ""
            )}
          </div>
        </div> */}

        <div
          className="goc-dashbord-search-filter"
          onClick={() => setShowLogout(true)}
        >
          <i class="fa-solid fa-right-from-bracket"></i>LogOut
        </div>
      </div>

      <div className="goc-dashbord-main-show-data-warpper-row">
        {viewCompany === "Garage On Call" ? (
          <GocLeadsComponent role="admin" logout={logout} />
        ) : viewCompany === "Repair Buddy" ? (
          <RepairBuddyLeadComponent role="admin" logout={logout} />
        ) : viewCompany === "Fluffy Touch" ? (
          <FluffyTouchLeadComponent role="admin" logout={logout} />
        ) : viewCompany === "Glazma" ? (
          <GlazmaLeadComponent role="admin" logout={logout} />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AdminDashboard;
